import {
  CLEAN_PLUMENU,
  SET_PLUMENU,
  SET_PLUMENU_LIST,
  SYNC_FAILED,
  SYNC_FINISHED,
  SYNC_INITIATED,
  PLUMENU_CREATED,
  PLUMENU_UPDATED,
  UPDATE_INITIATED,
  CREATE_INITIATED,
  PLUMENU_DELETED,
  DELETE_INITIATED,
  SET_PLUMENU_ASSOCIATED_GROUPS,
} from './actionTypes';
import {
  IFailedSyncAction,
  ISetPLUMenuAction,
  ISetPLUMenusAction,
  IPLUMenusAction,
  IPLUMenusState,
  IPLUMenuState,
  IDeletePLUMenuAction,
  ISetPLUMenusAssociatedGroupsAction,
} from './types';

const initialSync = {
  syncing: false,
  updateInitiated: false,
  createInitiated: false,
  deleteInitiated: false,
};

const resetActionsSync = {
  error: null,
  pluMenuUpdated: false,
  pluMenuCreated: false,
  pluMenuDeleted: false,
};

export const initialState = {
  loaded: false,
  pluMenus: [],
  pluMenu: null,
  pluActiveGroupIds: null,
  pluAssociatedGroups: null,
  filtering: false,
  ...initialSync,
  ...resetActionsSync,
};

export const reducer = (
  state: IPLUMenusState = initialState,
  action: IPLUMenusAction
): IPLUMenusState => {
  switch (action.type) {
    case SYNC_INITIATED:
      return { ...state, ...resetActionsSync, syncing: true };
    case SYNC_FINISHED:
      return { ...state, ...initialSync };
    case SET_PLUMENU_LIST:
      return {
        ...state,
        pluMenus: (action as ISetPLUMenusAction).payload,
        loaded: true,
      };
    case SET_PLUMENU:
      return {
        ...state,
        pluMenu: (action as ISetPLUMenuAction).payload,
      };
    case SET_PLUMENU_ASSOCIATED_GROUPS:
      return {
        ...state,
        pluAssociatedGroups: (action as ISetPLUMenusAssociatedGroupsAction).payload
          ?.pluAssociatedGroups,
        filtering: (action as ISetPLUMenusAssociatedGroupsAction).payload?.filtering,
        ...((action as ISetPLUMenusAssociatedGroupsAction).payload?.filtering === false && {
          pluActiveGroupIds: (action as ISetPLUMenusAssociatedGroupsAction).payload
            ?.pluActiveGroupIds,
        }),
      };
    case PLUMENU_UPDATED:
      return {
        ...state,
        pluMenuUpdated: true,
      };
    case UPDATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        updateInitiated: true,
      };
    case PLUMENU_CREATED:
      return {
        ...state,
        pluMenuCreated: true,
      };
    case CREATE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        createInitiated: true,
      };
    case PLUMENU_DELETED:
      return {
        ...state,
        pluMenus: state.pluMenus.filter(
          (pluMenu: IPLUMenuState) => pluMenu.pluMenuId !== (action as IDeletePLUMenuAction).payload
        ),
        pluMenuDeleted: true,
      };
    case DELETE_INITIATED:
      return {
        ...state,
        ...resetActionsSync,
        deleteInitiated: true,
      };
    case CLEAN_PLUMENU:
      return {
        ...state,
        pluMenu: null,
      };
    case SYNC_FAILED:
      return { ...state, error: (action as IFailedSyncAction).payload };
    default:
      return state;
  }
};
